import type { Locale } from '@/i18n/locales';

export type Currency = 'sek' | 'eur' | 'nok';

export const getCurrencyByLocale = (locale: Locale) => {
  const countryLocaleCurrency: Record<Locale, Currency> = {
    sv: 'sek',
    fi: 'eur',
    nb: 'nok',
  };
  return countryLocaleCurrency[locale];
};
